<template>
  <b-card>
    <b-row class="color_config_header">
      <b-col cols="9" class="text-left">
        <h4>{{ $t('CONFIGURED.RANGE') }}</h4>
      </b-col>
      <b-col cols="3" class="text-center">
        <h4>{{ $t('CONFIGURED.COLOR') }}</h4>
      </b-col>
    </b-row>
    <b-table show-empty :empty-text="$t('COMMON.NO_RECORD')" :items=rangeColors :fields="fields" thead-class="hidden_header" class="config-table">
      <template slot="color_code" slot-scope="data">
        <range :start="data.item.min_range" :end="data.item.max_range" @colorSelected="data.item.color_code = $event" :color="data.item.color_code" ></range>
      </template>
    </b-table>
    <div slot="footer" align="center">
      <b-button type="reset" class="button-style" variant="gray"  @click="resetColors"><i class="fa fa-ban"></i> {{ $t('COMMON.RESET') }}</b-button>
      <b-button type="submit" class="button-style" variant="secondary" @click="updateColors"><i class="fa fa-save"></i> {{ $t('COMMON.SAVE') }} </b-button>
    </div>
  </b-card>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import range from './range'

export default {
  data () {
    return {
      rangeColors: null,
      originalColors: null,
      fields: [{ key: 'color_code' }]
    }
  },
  components: {
    range
  },
  computed: {
    ...mapGetters(['idToken', 'selectedRolesData', 'isAdminRole'])
  },
  created () {
    let vm = this
    Vue.axios.get('/settings/confidence_colors', { headers: { Authorization: `Bearer ${vm.idToken}` } })
      .then(res => {
        vm.rangeColors = res.data.colors.map(color => Object.assign({}, color))
        vm.originalColors = res.data.colors.map(color => Object.assign({}, color))
      })
      .catch(error => {
        if (error.status === 401) {
          Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          console.log(this.$t('COMMON.MSG_EXPIRED'))
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  methods: {
    resetColors () {
      this.rangeColors = this.originalColors.map(color => Object.assign({}, color))
    },
    updateColors () {
      var formData = new window.FormData()
      formData.append('confidence_colors', JSON.stringify(this.rangeColors))
      Vue.axios.post('/settings/confidence_colors/batch_update', formData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          Vue.toasted.show(this.$t('CONFIGURED.CC_SUCCESS'))
        }, error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
          console.log(error)
        })
      this.originalColors = this.rangeColors.map(color => Object.assign({}, color))
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
    background: #ebeff3;
    border-radius: 10px;
  }

  .color_config_header {
    background: #ebeff3;
    margin: 0 1rem;
    padding: 0.5rem;
  }

  .card-footer {
    background-color: #ebeff3;
    border-radius: 10px;
    padding-top: 0;
  }

  .table {
    background-color: #ebeff3;
  }
</style>
<style>
  .panel-option button {
    color: red;
    background-color: white;
  }
  .panel-option button ,.panel-option button:active:focus,
  .panel-option button:hover, .panel-option button:active,
  .panel-option .btn:not(:disabled):not(.disabled):active{
    color: inherit;
    background-color: inherit;
    border: none;
    box-shadow: none;
    padding: 5px 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/settings/confidenceColors.vue